export const reviews = [
  {
    id: '1',
    userName: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=A%20trendy%20young%20Chinese%20person%20avatar%20in%20modern%20style%2C%20casual%20portrait%2C%20clean%20simple%20background%2C%20editorial%20photography%2C%20soft%20lighting&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    rating: 4.8,
    content: '这个网站太顶了！每天都能吃到最新鲜的瓜，推送速度比微博还快。关键是很多料其他平台根本不敢发，911是真的敢说真话。已经推荐给身边所有爱吃瓜的朋友了！',
    date: '2026-06-30',
  },
  {
    id: '2',
    userName: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20modern%20Chinese%20young%20adult%20portrait%20avatar%2C%20trendy%20style%2C%20clean%20white%20background%2C%20editorial%20photography%2C%20soft%20natural%20lighting&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    rating: 4.5,
    content: '每天睡前必刷，不刷睡不着。网红翻车专区是我最爱，看那些平时装得很的主播翻车太解压了哈哈哈。希望更新能再勤快点，有时候等新料等到心痒痒。',
    date: '2026-06-29',
  },
  {
    id: '3',
    userName: '八卦研究员',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylish%20Chinese%20young%20woman%20portrait%2C%20modern%20fashionable%20look%2C%20clean%20simple%20background%2C%20editorial%20photography%2C%20soft%20professional%20lighting&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    rating: 5.0,
    content: '作为资深吃瓜群众，911爆料网的信息准确度在同类网站里算很高的。不像有些营销号天天发假料骗流量。这里的大部分爆料都有实锤，而且更新速度巨快，值得信赖！',
    date: '2026-06-28',
  },
  {
    id: '4',
    userName: '互联网嘴替',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20Chinese%20young%20person%20portrait%20with%20trendy%20style%2C%20casual%20look%2C%20clean%20neutral%20background%2C%20editorial%20photography%2C%20soft%20lighting&width=120&height=120&seq=avatar-user-04&orientation=squarish',
    rating: 4.6,
    content: '说实话，这个网站已经成为我们办公室每天午休的社交货币了。谁要是不刷911，午休聊天都插不上嘴。每日大赛投票特别好玩，已经成了我们办公室的固定节目。',
    date: '2026-06-27',
  },
];